// code to set title based on this url: https://toddmotto.com/dynamic-page-titles-angular-2-router-events

import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ConfigService, UserComponent } from './shared';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor (
    private configService: ConfigService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.configService.populate();

  //   this.router.events
  //     .pipe(filter((event) => event instanceof NavigationEnd),
  //     map(() => this.activatedRoute),
  //     map((route) => {
  //       while (route.firstChild) {
  //         route = route.firstChild;
  //       }
  //       return route;
  //     }),
  //     filter((route) => route.outlet === 'primary'),
  //     mergeMap((route) => route.data))
  //     .subscribe((event) => this.titleService.setTitle(event['title']));
  }
}
